@if (isAuthenticated$ | async) {
  <app-cookies-banner></app-cookies-banner>
}

<router-outlet></router-outlet>
